import { render, staticRenderFns } from "./hero-text-item.vue?vue&type=template&id=91d0d28e&scoped=true"
import script from "./hero-text-item.vue?vue&type=script&lang=js"
export * from "./hero-text-item.vue?vue&type=script&lang=js"
import style0 from "./hero-text-item.vue?vue&type=style&index=0&id=91d0d28e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d0d28e",
  null
  
)

export default component.exports